export default __webpack_public_path__ + "static/aws-edede1ab617c2c801f98ba21f91b05ca.png";